module.exports = __webpack_public_path__ + "img/icon_topinfo@2x.def6ba55.png";